import React from 'react';
import { Box } from '@mui/material';
import UserMessageSkeleton from './UserMessageSkeleton';
import ChatLoader from './ChatLoader';

const ConversationSkeleton = ({ isMobile = false }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '100%',
        p: isMobile ? 1 : 2, // Less padding on mobile
        animation: 'fadeIn 0.5s ease-in-out',
      }}
    >
      {/* First user message skeleton */}
      <UserMessageSkeleton isMobile={isMobile} />
      
      {/* First AI response skeleton using existing ChatLoader */}
      <Box sx={{ 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'flex-start', 
        mb: 2,
        px: isMobile ? 0.5 : 0, // Slight padding adjustment on mobile
      }}>
        <ChatLoader message="Loading conversation..." />
      </Box>
      
      {/* Second user message skeleton */}
      <UserMessageSkeleton isMobile={isMobile} />
      
      {/* Second AI response skeleton */}
      <Box sx={{ 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'flex-start', 
        mb: 2,
        px: isMobile ? 0.5 : 0, // Slight padding adjustment on mobile
      }}>
        <ChatLoader message="Loading messages..." />
      </Box>

      {/* Global CSS Animations */}
      <style jsx global>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </Box>
  );
};

export default ConversationSkeleton;
